import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

      export const updateBookingExpense = createAsyncThunk('appDriverBookingExpense/updateBookingExpense', async (params) => {
        const response = await axios.post(' https://api.zasway.com:8443/DriverBookingExpense/Update', params, {mode:'cors'})
        return {
          status: response.status,
          data: response.data
        }
      })
      export const deleteBookingExpense = createAsyncThunk('appDriverBookingExpense/deleteBookingExpense', async (params) => {
        const response = await axios.post(' https://api.zasway.com:8443/DriverBookingExpense/DeleteExpense', params, {mode:'cors'})
         
        return response.data
      })
      
      export const getDeclineExpenseData = createAsyncThunk('appDriverBookingExpense/getDeclineExpenseData', async (params) => {
        const response = await axios.post(' https://api.zasway.com:8443/DriverBookingExpense/GetDeclinedBookExpenses', params, {mode:'cors'})
        return {
          params,
          data: response.data.data,
          allData: response.data.allData,
          totalPages: response.data.total
        }
      })

      export const getApprovedExpenseData = createAsyncThunk('appDriverBookingExpense/getApprovedBookExpenses', async (params) => {
        const response = await axios.post(' https://api.zasway.com:8443/DriverBookingExpense/GetApprovedBookExpenses', params, {mode:'cors'})
        return {
          params,
          data: response.data.data,
          allData: response.data.allData,
          totalPages: response.data.total
        }
      })

      export const getPendingExpenseData = createAsyncThunk('appDriverBookingExpense/getPendingExpenseData', async (params) => {
        
        const response = await axios.post(' https://api.zasway.com:8443/DriverBookingExpense/GetPendingBookExpenses', params, {mode:'cors'})
        return {
          params,
          allData: response.data.allData
        }
      })


  export const appDriverBookingExpenseSlice = createSlice({
    name: 'appDriverBookingExpense',
    initialState: {
      approvedExpenseData: [],
      approvedExpenseTotal: 1,
      approvedExpenseParams: {},
      approvedExpenseAllData: [],
      declineExpenseData: [],
      declineExpenseTotal: 1,
      declineExpenseParams: {},
      declineExpenseAllData: [],
      pendingExpenseData: [],
      pendingExpenseTotal: 1,
      pendingExpenseParams: {},
      pendingExpenseAllData: []
    },
    reducers: {},
    extraReducers: builder => {
      builder
        
        .addCase(getDeclineExpenseData.fulfilled, (state, action) => {
          
          state.declineExpenseData = action.payload.data
          state.declineExpenseAllData = action.payload.allData
          state.declineExpenseTotal = action.payload.totalPages
          state.declineExpenseParams = action.payload.params
        })


        .addCase(getApprovedExpenseData.fulfilled, (state, action) => {
          
          state.approvedExpenseData = action.payload.data
          state.approvedExpenseAllData = action.payload.allData
          state.approvedExpenseTotal = action.payload.totalPages
          state.approvedExpenseParams = action.payload.params
        })

        .addCase(getPendingExpenseData.fulfilled, (state, action) => {
          
          state.pendingExpenseAllData = action.payload.allData
          state.pendingExpenseParams = action.payload.params
        })
        
    }
  })
  
  export default appDriverBookingExpenseSlice.reducer
